// extracted by mini-css-extract-plugin
module.exports = {"root":"cmsBlock_root__VmxKr m-xs","content":"cmsBlock_content__m2bf5"};